import { LoadingOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, Modal, Progress, Spin } from 'antd'
import { useState } from 'react'
import { parseEther } from 'viem'
import { useAccount } from 'wagmi'

import { AppAdmin } from 'api/app-admin'
import { Noti } from 'component/noti/toast'
import { CONFIRMATIONS_BLOCK, ContractStatusEnum } from 'constants/index'
import { useVestingContext } from 'context/vesting-context-provider'
import { customErrorContract } from 'hooks/contract/use-contract-viem'
import { useWeb3ModalHook } from 'hooks/use-web3-modal-hook'
import { clientWallet, publicWallet } from 'libs/viem/config'

interface IButtonImportProps {
  contract: any
  disable?: boolean
  onAfterImport: () => void
}

const ButtonImport = ({ disable, contract, onAfterImport }: IButtonImportProps) => {
  const { address } = useAccount()

  const { type } = useVestingContext()

  const [loadingContract, setLoadingContract] = useState(false)

  const [processedWallets, setProcessedWallets] = useState(0)

  const { handleConnect } = useWeb3ModalHook()

  const [totalResults, setTotalResults] = useState(0)

  const [openModal, setOpenModal] = useState(false)

  const importWhiteList = async () => {
    try {
      if (!contract) {
        Noti('error', 'Please connect wallet', 3000)
        return
      }
      if (!type) return
      setProcessedWallets(0)
      setLoadingContract(true)
      // get data error + new
      const BATCH_SIZE = 100
      const res = await AppAdmin.getListVesting({
        type,
        limit: BATCH_SIZE,
        status: false,
      })
      if (res?.data.code === 200) {
        const totalPages = res?.data?.data?.totalPages
        setTotalResults(res?.data?.data?.totalResults)
        let page = 1
        setOpenModal(true)
        while (page <= totalPages) {
          const list: any[] = []
          const fullAddressList: any[] = []
          const fullAmountList: any[] = []
          const resPage = await AppAdmin.getListVesting({
            type,
            limit: BATCH_SIZE,
            status: false,
          })
          if (resPage.data?.code === 200) {
            const data = resPage?.data?.data?.results || []
            data?.map((item) => {
              // if (!item.amountContract && item.amount) {
              //   const formatted = parseEther(item.amount?.toString());
              //   fullAddressList.push(item.ownerAddress);
              //   fullAmountList.push(formatted);
              //   list.push({
              //     ownerAddress: item?.ownerAddress,
              //     amount: item.amount,
              //   });
              // }
              const formatted = parseEther((item?.amount || '0').toString())
              fullAddressList.push(item.ownerAddress)
              fullAmountList.push(formatted)
              list.push({
                ownerAddress: item?.ownerAddress,
                amount: item.amount,
              })
            })
            if (list?.length) {
              const { request } = await contract.simulate.addWhitelistMulti(
                [fullAddressList, fullAmountList],
                {
                  account: address,
                }
              )
              const txHashAddWallet = await clientWallet?.writeContract(request)

              if (txHashAddWallet) {
                const receiptAddWhiteList = await publicWallet.waitForTransactionReceipt({
                  hash: txHashAddWallet,
                  confirmations: CONFIRMATIONS_BLOCK,
                })

                if (receiptAddWhiteList.status === ContractStatusEnum.SUCCESS) {
                  await AppAdmin.vestingChecking({ type: type, data: list })
                }
                setProcessedWallets((pre) => {
                  return pre + list.length
                })
              }
            }
          }
          page++
        }
        setOpenModal(false)
      }
      setLoadingContract(false)
      onAfterImport()
    } catch (error: any) {
      setLoadingContract(false)
      setOpenModal(false)
      const errorMessage = customErrorContract(error)
      Noti('error', errorMessage, 3000)
    }
  }

  return (
    <>
      <Button
        type="primary"
        style={{ width: 300 }}
        disabled={loadingContract || disable}
        onClick={() => {
          if (contract?.address) importWhiteList()
          else handleConnect()
        }}
        size="large"
        icon={loadingContract ? undefined : <UploadOutlined />}
      >
        {loadingContract ? <Spin /> : 'Import Whitelist to contract'}
      </Button>
      <Modal
        title={false}
        visible={openModal}
        footer={false}
        wrapClassName="modal-confirm"
        centered
      >
        <div className="spin-stake">
          <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 60 }} spin />} />
        </div>
        <p className="modal-text1">Your request is being processed. Please wait...</p>
        <Progress
          percent={Math.round((processedWallets / totalResults) * 100)}
          status="active"
          strokeWidth={10}
        />
        <div className="modal-text2">
          <div>
            Processing: {processedWallets}/{totalResults} wallets
          </div>
        </div>
      </Modal>
    </>
  )
}
export default ButtonImport
